import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.scss";
import Landing from "./components/landing/Landing";
import Terms from "./components/landing/Term/Terms";
import Cookies from "./components/landing/Cookies/Cookies";
import CookieBanner from "./components/landing/Cookies/CookieBanner";
import Privacypolicy from "./components/landing/Privacypolicy/Privacypolicy";
import Career from "./components/Career/Career";
import CareerDetail from "./components/Career/CareerDetail";
import CareerDetail1 from "./components/Career/CareerDetail1";
import CareerDetail2 from "./components/Career/CareerDetail2";
import CareerDetail3 from "./components/Career/CareerDetail3";
import CareerDetail4 from "./components/Career/CareerDetail4";
import NotFound from "./components/NotFound";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function hideBlockingIframes() {
  document.querySelectorAll("iframe").forEach((frame) => {
    const id = (frame.id || "").toLowerCase();
    const src = (frame.getAttribute("src") || "").toLowerCase();
    const style = frame.getAttribute("style") || "";
    const blocks =
      id.includes("webpack-dev-server") ||
      id.includes("netlify-identity") ||
      id.includes("walletconnect") ||
      src.includes("netlify-identity") ||
      src.includes("walletconnect") ||
      /z-index:\s*2147483647/.test(style);
    if (blocks) {
      frame.style.pointerEvents = "none";
      frame.style.display = "none";
    }
  });
}

function App() {
  useEffect(() => {
    hideBlockingIframes();
    const observer = new MutationObserver(hideBlockingIframes);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <ToastContainer style={{ fontSize: 20, width: "400px" }} />
      <Router>
        <CookieBanner />
        <Switch>
          <Route exact path="/" render={() => <Landing />} />
          <Route exact path="/terms" render={() => <Terms />} />
          <Route exact path="/privacy" render={() => <Privacypolicy />} />
          <Route exact path="/cookies" render={() => <Cookies />} />
          <Route exact path="/career" render={() => <Career />} />
          <Route exact path="/headofmarketing" render={() => <CareerDetail />} />
          <Route exact path="/marketingoperationsmanager" render={() => <CareerDetail1 />} />
          <Route exact path="/headofprandcommunications" render={() => <CareerDetail2 />} />
          <Route exact path="/headofcommunity" render={() => <CareerDetail3 />} />
          <Route exact path="/supportspecialist" render={() => <CareerDetail4 />} />
          <Route path="*" render={() => <NotFound />} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
